module.exports = __webpack_public_path__ + "10_hige_black.6e9f601b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer3/10_hige_black.png
// module id = jpwU
// module chunks = 0